@if(orderLine){

<div class="item-price-wrapper multi-items">
  @if(orderLine?.quantity > 1){

    @if(orderLine.proratedLinePriceWithTax | formatPriceUnit:orderLine?.quantity | async; as totalLinePriceAfterDiscount){
      <div class="each-item-price">
        {{totalLinePriceAfterDiscount}}
      </div>
      } @else {
    
      <p-progressSpinner styleClass="c-loader small centered-vertically " strokeWidth="2" fill="var(--surface-ground)"
        animationDuration=".5s"></p-progressSpinner>
    
      }

<!--
    @if(orderLine.unitPriceWithTax | formatPrice | async; as unitPrice){
      <div class="each-item-price">
        Each: {{unitPrice}}
      </div>
      } @else {
    
      <p-progressSpinner styleClass="c-loader small centered-vertically " strokeWidth="2" fill="var(--surface-ground)"
        animationDuration=".5s"></p-progressSpinner>
    
      }
-->
  }
    @if(orderLine.proratedLinePriceWithTax | formatPrice | async; as totalLinePriceAfterDiscount){
      <div class="total-price">
        {{totalLinePriceAfterDiscount}}
      </div>
      } @else {
    
      <p-progressSpinner styleClass="c-loader small centered-vertically " strokeWidth="2" fill="var(--surface-ground)"
        animationDuration=".5s"></p-progressSpinner>
    
      }
  

  
      @if (orderLine?.discounts?.length > 0) {
        @if(orderLine.linePriceWithTax | formatPrice | async; as totalLinePrice){
          <div class="total-before-discount">
            {{totalLinePrice}}
          </div>
          } @else {
        
          <p-progressSpinner styleClass="c-loader small centered-vertically " strokeWidth="2" fill="var(--surface-ground)"
            animationDuration=".5s"></p-progressSpinner>
        
          }

      }
   
</div>

} @else {
@if (false) {
<div class="item-price-wrapper single-item">
  <div class="item-price">{{ product.totalValue | number }} {{product.currency}}</div>
  @if (true) {
  <div class="total-before-discount">{{ product.totalValue*2+9000 | number }} {{product.currency}}</div>
  }
</div>
} @else {
<div class="item-price-wrapper multi-items">
  <div class="each-item-price">Each: {{ product.totalValue | number }} {{product.currency}}</div>
  <div class="total-price">{{ product.totalValue*2 | number }} {{product.currency}}</div>
  @if (true) {
  <div class="total-before-discount">{{ product.totalValue*2+9000 | number }} {{product.currency}}</div>
  }
</div>
}
}
